/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_ActiveInputs */

const en_portal_active = /** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Active`)
};

const es_portal_active = /** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Activo`)
};

const fr_portal_active = /** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portail actif`)
};

const de_portal_active = /** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Aktiv`)
};

const id_portal_active = /** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Aktif`)
};

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const ja_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const zh_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const ar_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const it_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const ru_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const pt_portal_active = en_portal_active;

/** @type {(inputs: Portal_ActiveInputs) => LocalizedString} */
const ko_portal_active = en_portal_active;

/**
* | output |
* | --- |
* | "Portal Active" |
*
* @param {Portal_ActiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const portal_active = /** @type {((inputs?: Portal_ActiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_ActiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portal_active(inputs)
	if (locale === "es") return es_portal_active(inputs)
	if (locale === "fr") return fr_portal_active(inputs)
	if (locale === "de") return de_portal_active(inputs)
	if (locale === "ja") return ja_portal_active(inputs)
	if (locale === "zh") return zh_portal_active(inputs)
	if (locale === "ar") return ar_portal_active(inputs)
	if (locale === "id") return id_portal_active(inputs)
	if (locale === "it") return it_portal_active(inputs)
	if (locale === "ru") return ru_portal_active(inputs)
	if (locale === "pt") return pt_portal_active(inputs)
	return ko_portal_active(inputs)
});